import Vue from 'vue';

Vue.component('stock-cost-index', () =>
    import(/* webpackChunkName: 'stock-cost-index' */ './stock-cost-index.vue'),
);
